import { storyPageContent } from "../data/services";
import { motion } from "framer-motion";
import ServicesBanner from "../components/common/ServicesBanner";
import userImg from "../assets/icons/CLIENTImg.png";
import OpportunitiesImg from "../assets/icons/OPPORTUNITIESImg.png";
import ChallengesImg from "../assets/icons/CHALLENEGS.jpg";
import SuccessImg from "../assets/icons/SUCCESS.jpg";
const SuccessStory3 = () => {

  const { bannerTitle, bannerImage } =
    storyPageContent;
  const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: { delay: i * 0.2, duration: 0.5 },
    }),
  };
  const cards = [
    {
      title: "クライアントの背景",
      img: userImg,
      description:
        "クライアントは、日本で上場している決済サービスプロバイダーとして、全国の24時間365日営業のコンビニエンスストアを含む企業向けに、安全で効率的な金融取引を保証しています。 \n また、システム運用（SysOpe）と監視という2つの重点業種を運用し、業界標準とコンプライアンス要件を満たしながら中断のない支払い処理をサポートしています。 ",
    },
    {
      title: "機会",
      img: OpportunitiesImg,
      description:
        "• クライアントが求めていたのは、スケジュールされたタスク（IFRS 財務報告など）とリクエストベースのタスクの処理における運用効率の向上でした。 \n • また、中断のない支払いサービスに不可欠なアプリケーションとインフラストラクチャの高可用性を維持するために、アラートを24時間365日監視する必要がありました。 \n • オンプレミスからクラウドへのスムーズな移行のためにワークフローを調整するなど、インフラストラクチャ管理の効率化も必要でした。 ",
    },
    {
      title: "課題",
      img: ChallengesImg,
      description:
        "• タスクの過負荷：大量のスケジュールされたタスクとリクエストベースのタスクを管理すると、多くの場合、バックログが発生。\n • 稼働時間のプレッシャー：わずかなダウンタイムでも業務に影響する可能性がある24時間365日営業のコンビニエンスストアに対し、中断のないサービスを確保。 \n • アラート管理：アプリケーションとインフラストラクチャ全体で900種類を超えるアラートを処理するため優先順位付けが困難に。  ",
    },
    {
      title: "解決策と成功",
      img: SuccessImg,
      description:
        "• SysOpeの最適化：スケジュールされたタスクを合理化し、バックログになってしまったタスクを効果的に優先順位付けするためのタスク管理システムを実装しました。\n • IFRS レポートなどの繰り返し発生するタスクの処理を自動化し、効率と精度を向上させました。 \n  • 監視機能の強化：重大なアラートに応答してより迅速かつ確実に解決するため、優先度ベースのフレームワークを導入しました。 \n  • そのためにSlackと実時間ダッシュボードを介して集中型のワークフローを確立し、アラートをシームレスに監視できるようになりました。 ",
    },
  ];
  return (
    <div className="bg-gradient-to-b from-white to-gray-100 mb-5 mx-auto">
      {/* Banner Section */}
      <ServicesBanner title={bannerTitle} heroImage={bannerImage} />
      <div className="max-w-5xl mx-auto md:px-10 lg:px-10 lg:max-w-fit">
        <div className="flex justify-center items-center">
          {/* Header Section */}
          <div className="m-5">
            <h1 className="text-3xl font-bold mt-2">
            <span>デジタル決済サービスプロバイダー</span>
            </h1>
          </div>
        </div>
        <div className="grid md:grid-cols-2 sm:grid-cols-1 gap-x-10 gap-y-10 w-full max-w-6xl mx-auto">
          {cards.map((card, i) => (
            <motion.div
              key={card.title}
              custom={i}
              initial="hidden"
              animate="visible"
              variants={cardVariants}
              className="bg-white rounded-2xl shadow-md hover:shadow-xl hover:shadow-blue-100 p-10 transition duration-300 ease-in-out"
            >
              <div className="flex items-center gap-4 mb-4">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-16 h-16 rounded-full border border-gray-200"
                />
                <h3 className="text-2xl font-semibold text-blue-700">
                  {card.title}
                </h3>
              </div>
              <p className="text-gray-800 leading-relaxed text-lg">
                {card.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SuccessStory3;